import {
  ADD_FUNDS,
  AFFILIATES,
  API,
  CONTACT,
  MASS_ORDER,
  NEW_ORDER,
  ORDERS,
  SERVICES,
  TICKETS,
  PLANS,
  CHILD_PANEL,
} from "pages/routes/route.constant";
import {
  UserOutlined,
  UserAddOutlined,
  // Other imports...
} from "@ant-design/icons";
//@ts-ignore
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { GetBalance, GetUserName } from "utils/user";
type SideBarProps = {
  onClose?: () => void;
};
const Sidebar = ({ onClose }: SideBarProps) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const { t } = useTranslation();

  const isActive = (path: string) => {
    return (
      currentPath === path || (path !== "/" && currentPath.startsWith(path))
    );
  };

  interface NavItem {
    to: string;
    label: string;
    icon: string;
  }

  const getLinkClassName = (path: string) => {
    return isActive(path)
      ? "bg-[#EA1261] text-white rounded-lg p-3 flex items-center gap-4"
      : "bg-white hover:bg-gray-50 rounded-lg p-3 flex items-center gap-4";
  };

  const getTextClassName = (path: string) => {
    return isActive(path)
      ? "font-medium text-[15px] text-white"
      : "font-medium text-[15px] text-[#212121]";
  };

  const getColorOnIsActive = (path: string) => {
    return isActive(path) ? "#fff" : "#212121";
  };

  // const getStrokeColor = (path: string) => {
  //   return isActive(path) ? "currentColor" : "#212121";
  // };

  const navItemsData: NavItem[] = [
    { to: NEW_ORDER, label: t("newOrder"), icon: "new-order" },
    { to: SERVICES, label: t("services"), icon: "service" },
    { to: ORDERS, label: t("orders"), icon: "orders" },
    { to: ADD_FUNDS, label: t("addFunds"), icon: "add-fund" },
    { to: AFFILIATES, label: t("affiliates"), icon: "affiliate" },
    { to: CONTACT, label: t("contact"), icon: "contact" },
    { to: API, label: t("api"), icon: "api" },
    { to: TICKETS, label: t("tickets"), icon: "tickets" },
    { to: MASS_ORDER, label: t("massOrder"), icon: "mass-order" },
    // { to: CHILD_PANEL, label: t("Child Panel"), icon: "child-panel" },
    { to: PLANS, label: t("Child panel"), icon: "plans" },
  ];

  const icon = (iconName: string) => {
    switch (iconName) {
      case "new-order":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5593 8.55566H16.3208C16.08 8.55566 15.8489 8.65322 15.6786 8.82686C15.5083 9.00051 15.4126 9.23602 15.4126 9.48159C15.4126 9.72716 15.5083 9.96267 15.6786 10.1363C15.8489 10.31 16.08 10.4075 16.3208 10.4075H20.5593C20.8002 10.4075 21.0312 10.31 21.2015 10.1363C21.3718 9.96267 21.4675 9.72716 21.4675 9.48159C21.4675 9.23602 21.3718 9.00051 21.2015 8.82686C21.0312 8.65322 20.8002 8.55566 20.5593 8.55566Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.5317 7.32095V11.6419C17.5317 11.8875 17.6274 12.123 17.7978 12.2967C17.9681 12.4703 18.1991 12.5679 18.44 12.5679C18.6809 12.5679 18.9119 12.4703 19.0822 12.2967C19.2525 12.123 19.3482 11.8875 19.3482 11.6419V7.32095C19.3482 7.07537 19.2525 6.83986 19.0822 6.66622C18.9119 6.49257 18.6809 6.39502 18.44 6.39502C18.1991 6.39502 17.9681 6.49257 17.7978 6.66622C17.6274 6.83986 17.5317 7.07537 17.5317 7.32095Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12.9906 8.55566H7.77122C7.63689 8.55575 7.50426 8.5862 7.38288 8.64483C7.26149 8.70347 7.15438 8.78882 7.06925 8.89474C6.98411 9.00066 6.92308 9.12451 6.89056 9.25737C6.85803 9.39023 6.85481 9.52879 6.88114 9.66307L8.91317 20.0236C9.06409 20.7933 9.472 21.486 10.0675 21.9837C10.663 22.4814 11.4092 22.7533 12.1792 22.7532H23.95C24.72 22.7533 25.4662 22.4814 26.0617 21.9837C26.6572 21.486 27.0651 20.7933 27.216 20.0236L28.9586 11.1396C29.0203 10.8262 29.0129 10.5027 28.937 10.1925C28.8612 9.88228 28.7187 9.59313 28.5198 9.34591C28.321 9.09868 28.0708 8.89955 27.7873 8.76289C27.5039 8.62623 27.1941 8.55545 26.8805 8.55566H23.8894C23.6485 8.55566 23.4175 8.65322 23.2472 8.82686C23.0769 9.00051 22.9812 9.23602 22.9812 9.48159C22.9812 9.72716 23.0769 9.96267 23.2472 10.1363C23.4175 10.31 23.6485 10.4075 23.8894 10.4075H26.8805C26.9254 10.4073 26.9697 10.4173 27.0103 10.4368C27.0509 10.4563 27.0867 10.4847 27.1151 10.5201C27.1435 10.5554 27.1638 10.5968 27.1746 10.6412C27.1853 10.6856 27.1862 10.7319 27.1772 10.7767L25.4346 19.6606C25.366 20.0105 25.1806 20.3254 24.9099 20.5516C24.6392 20.7778 24.3 20.9014 23.95 20.9013H12.1792C11.8292 20.9014 11.49 20.7778 11.2193 20.5516C10.9486 20.3254 10.7631 20.0105 10.6945 19.6606L8.87927 10.4075H12.9906C13.2314 10.4075 13.4625 10.31 13.6328 10.1363C13.8031 9.96267 13.8988 9.72716 13.8988 9.48159C13.8988 9.23602 13.8031 9.00051 13.6328 8.82686C13.4625 8.65322 13.2314 8.55566 12.9906 8.55566Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.90824 5.46904H5.87851C6.02383 5.46904 6.14856 5.57398 6.1752 5.71966L7.48427 12.7406C7.52924 12.982 7.66639 13.1952 7.86556 13.3334C8.06473 13.4716 8.3096 13.5235 8.54631 13.4777C8.78301 13.4318 8.99216 13.292 9.12774 13.089C9.26332 12.8859 9.31423 12.6363 9.26927 12.395L7.96019 5.37398C7.86801 4.87992 7.60966 4.43412 7.22966 4.11343C6.84966 3.79274 6.37182 3.61724 5.87851 3.61719H3.90824C3.66736 3.61719 3.43634 3.71474 3.26602 3.88838C3.09569 4.06203 3 4.29754 3 4.54311C3 4.78868 3.09569 5.0242 3.26602 5.19784C3.43634 5.37149 3.66736 5.46904 3.90824 5.46904Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              d="M23.5142 28.0001C24.5174 28.0001 25.3307 27.171 25.3307 26.1482C25.3307 25.1255 24.5174 24.2964 23.5142 24.2964C22.511 24.2964 21.6978 25.1255 21.6978 26.1482C21.6978 27.171 22.511 28.0001 23.5142 28.0001Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              d="M13.2208 28.0001C14.224 28.0001 15.0372 27.171 15.0372 26.1482C15.0372 25.1255 14.224 24.2964 13.2208 24.2964C12.2176 24.2964 11.4043 25.1255 11.4043 26.1482C11.4043 27.171 12.2176 28.0001 13.2208 28.0001Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.4402 3C14.9308 3 12.0825 5.9037 12.0825 9.48148C12.0825 13.0593 14.9308 15.963 18.4402 15.963C21.9496 15.963 24.7979 13.0593 24.7979 9.48148C24.7979 5.9037 21.9496 3 18.4402 3ZM18.4402 4.85185C20.9469 4.85185 22.9814 6.92593 22.9814 9.48148C22.9814 12.037 20.9469 14.1111 18.4402 14.1111C15.9334 14.1111 13.899 12.037 13.899 9.48148C13.899 6.92593 15.9334 4.85185 18.4402 4.85185Z"
              fill={getColorOnIsActive(NEW_ORDER)}
            />
          </svg>
        );
      case "service":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.6213 14.6875H5.62867C4.73059 14.6875 4 13.9569 4 13.0588V8.06617C4 7.16809 4.73059 6.4375 5.62867 6.4375H10.6213C11.5194 6.4375 12.25 7.16809 12.25 8.06617V13.0588C12.25 13.9569 11.5194 14.6875 10.6213 14.6875ZM5.62867 7.9375C5.59455 7.93753 5.56185 7.9511 5.53772 7.97522C5.5136 7.99935 5.50003 8.03205 5.5 8.06617V13.0588C5.50003 13.0929 5.5136 13.1256 5.53772 13.1498C5.56185 13.1739 5.59455 13.1874 5.62867 13.1875H10.6213C10.6554 13.1874 10.6881 13.1739 10.7123 13.1498C10.7364 13.1256 10.7499 13.0929 10.75 13.0588V8.06617C10.7499 8.03205 10.7364 7.99935 10.7123 7.97522C10.6881 7.9511 10.6554 7.93753 10.6213 7.9375H5.62867ZM10.6213 25.5624H5.62867C4.73059 25.5624 4 24.8319 4 23.9338V18.9411C4 18.0431 4.73059 17.3125 5.62867 17.3125H10.6213C11.5194 17.3125 12.25 18.0431 12.25 18.9411V23.9338C12.25 24.8319 11.5194 25.5624 10.6213 25.5624ZM5.62867 18.8125C5.59455 18.8125 5.56185 18.8261 5.53772 18.8502C5.5136 18.8743 5.50003 18.907 5.5 18.9411V23.9338C5.50003 23.9679 5.5136 24.0006 5.53772 24.0247C5.56185 24.0488 5.59455 24.0624 5.62867 24.0625H10.6213C10.6554 24.0624 10.6881 24.0488 10.7123 24.0247C10.7364 24.0006 10.7499 23.9679 10.75 23.9338V18.9411C10.7499 18.907 10.7364 18.8743 10.7123 18.8502C10.6881 18.8261 10.6554 18.8125 10.6213 18.8125H5.62867ZM27.2499 10.1875H15.25C14.8358 10.1875 14.5 9.85168 14.5 9.43749C14.5 9.02331 14.8358 8.68749 15.25 8.68749H27.2499C27.6641 8.68749 27.9999 9.02331 27.9999 9.43749C27.9999 9.85168 27.6641 10.1875 27.2499 10.1875ZM23.1249 13H15.25C14.8358 13 14.5 12.6642 14.5 12.25C14.5 11.8358 14.8358 11.5 15.25 11.5H23.1249C23.5391 11.5 23.8749 11.8358 23.8749 12.25C23.8749 12.6642 23.5391 13 23.1249 13ZM27.2499 20.875H15.25C14.8358 20.875 14.5 20.5391 14.5 20.125C14.5 19.7108 14.8358 19.375 15.25 19.375H27.2499C27.6641 19.375 27.9999 19.7108 27.9999 20.125C27.9999 20.5391 27.6641 20.875 27.2499 20.875ZM23.1249 23.875H15.25C14.8358 23.875 14.5 23.5391 14.5 23.125C14.5 22.7108 14.8358 22.375 15.25 22.375H23.1249C23.5391 22.375 23.8749 22.7108 23.8749 23.125C23.8749 23.5391 23.5391 23.875 23.1249 23.875Z"
              fill={getColorOnIsActive(SERVICES)}
              stroke={getColorOnIsActive(SERVICES)}
              strokeWidth="0.25"
            />
          </svg>
        );
      case "orders":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2595 22.9195H11.0391V16.6176H12.2595V22.9195ZM16.5878 16.0717H15.3675V23.4653H16.5878V16.0717ZM20.9148 16.6176H19.6944V22.9195H20.9148V16.6176ZM28 13.6808H26.7977L24.8309 24.4636C24.5413 26.0616 23.2868 27.1783 21.7805 27.1783H10.2195C8.71412 27.1783 7.45915 26.062 7.16764 24.4636L5.20224 13.6808H4V12.3588H9.68881L11.2386 7.52258C11.7629 5.8821 13.1394 4.82178 14.7453 4.82178H17.2547C18.8588 4.82178 20.2352 5.88188 20.7613 7.52247L22.3098 12.3588H28V13.6808ZM10.9806 12.3588H21.0182L19.6085 7.95599C19.2555 6.85523 18.3316 6.14381 17.2547 6.14381H14.7453C13.6672 6.14381 12.7434 6.85501 12.3916 7.95566L10.9806 12.3588ZM25.5538 13.6808H6.44612L8.36485 24.2074C8.5419 25.1782 9.30451 25.8562 10.2195 25.8562H21.7805C22.6957 25.8562 23.4577 25.1785 23.6335 24.2081L25.5538 13.6808Z"
              fill={getColorOnIsActive(ORDERS)}
              stroke={getColorOnIsActive(ORDERS)}
              strokeWidth="0.35"
            />
          </svg>
        );
      case "add-fund":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.2109 26.9313H11.6842C11.351 26.9313 11.0595 26.7175 10.9449 26.4075C10.8304 26.0869 10.9241 25.7341 11.174 25.5204C11.4239 25.3066 11.6529 25.0287 11.8195 24.7294C12.1527 24.1842 12.3193 23.5643 12.3193 22.9336C12.3193 21.0203 10.7991 19.4597 8.93537 19.4597C8.16488 19.4597 7.43603 19.727 6.82171 20.2293C6.70716 20.3239 6.56878 20.383 6.42274 20.3998C6.2767 20.4166 6.12901 20.3904 5.99691 20.3243C5.86482 20.2582 5.75377 20.1548 5.67674 20.0263C5.5997 19.8979 5.55985 19.7496 5.56184 19.5987V14.9276C5.56184 12.2661 7.66509 10.1069 10.2577 10.1069H22.2109C24.8035 10.1069 26.9067 12.2661 26.9067 14.9276V16.4668C26.9067 16.9051 26.5527 17.2685 26.1258 17.2685H24.0226C23.6581 17.2685 23.325 17.4075 23.0855 17.664L23.0751 17.6747C22.7835 17.9633 22.6482 18.3588 22.6794 18.765C22.7419 19.4704 23.3978 20.0369 24.1475 20.0369H26.1258C26.5527 20.0369 26.9067 20.4004 26.9067 20.8386V22.1106C26.9067 24.7721 24.8035 26.9313 22.2109 26.9313ZM13.2981 25.328H22.2109C23.9393 25.328 25.3449 23.885 25.3449 22.1106V21.6403H24.1475C22.5753 21.6403 21.2425 20.4431 21.1176 18.9039C21.0343 18.0274 21.3467 17.1616 21.9714 16.531C22.5128 15.9645 23.2417 15.6545 24.0226 15.6545H25.3449V14.917C25.3449 13.1426 23.9393 11.6996 22.2109 11.6996H10.2577C8.5293 11.6996 7.12366 13.1426 7.12366 14.917V18.2091C7.70346 17.9718 8.32159 17.8485 8.94579 17.8457C11.6738 17.8457 13.8916 20.1225 13.8916 22.923C13.8916 23.7674 13.6833 24.6011 13.2981 25.328Z"
              fill={getColorOnIsActive(ADD_FUNDS)}
            />
            <path
              d="M6.34268 16.6804C5.91578 16.6804 5.56177 16.317 5.56177 15.8788V10.9939C5.56177 9.40127 6.54051 7.95826 7.9878 7.39175L16.255 4.18507C17.0984 3.85372 18.0563 3.9713 18.7956 4.50574C19.5453 5.04019 19.9826 5.90599 19.9826 6.83593V10.8977C19.9826 11.336 19.6286 11.6994 19.2017 11.6994C18.7748 11.6994 18.4208 11.336 18.4208 10.8977V6.83593C18.4208 6.42975 18.2334 6.05564 17.9002 5.82048C17.567 5.58532 17.1713 5.53188 16.7965 5.68152L8.52923 8.8882C7.68585 9.21956 7.11318 10.064 7.11318 10.9939V15.8788C7.12359 16.3277 6.76958 16.6804 6.34268 16.6804ZM24.1475 21.6401C22.5752 21.6401 21.2425 20.4429 21.1175 18.9037C21.0342 18.0165 21.3466 17.1507 21.9713 16.5201C22.5023 15.9643 23.2312 15.6543 24.0121 15.6543H26.1778C27.2086 15.6864 27.9999 16.5201 27.9999 17.5462V19.7481C27.9999 20.7743 27.2086 21.608 26.2091 21.6401H24.1475ZM26.157 17.2576H24.0225C23.6581 17.2576 23.3249 17.3966 23.0854 17.6531C22.7835 17.9524 22.6377 18.3586 22.6793 18.7648C22.7418 19.4702 23.3978 20.0367 24.1475 20.0367H26.1882C26.3236 20.0367 26.4485 19.9085 26.4485 19.7481V17.5462C26.4485 17.3859 26.3236 17.2683 26.157 17.2576Z"
              fill={getColorOnIsActive(ADD_FUNDS)}
            />
            <path
              d="M18.3167 16.242H11.0282C10.6013 16.242 10.2473 15.8786 10.2473 15.4403C10.2473 15.0021 10.6013 14.6387 11.0282 14.6387H18.3167C18.7436 14.6387 19.0976 15.0021 19.0976 15.4403C19.0976 15.8786 18.7436 16.242 18.3167 16.242ZM8.94577 27.9998C7.21735 27.9998 5.59306 27.0592 4.71844 25.5307C4.24989 24.7611 4 23.8525 4 22.9226C4 21.362 4.67679 19.919 5.85336 18.957C6.72798 18.2408 7.83167 17.8453 8.94577 17.8453C11.6738 17.8453 13.8915 20.1221 13.8915 22.9226C13.8915 23.8525 13.6416 24.7611 13.1731 25.5414C12.9232 25.9903 12.5796 26.3965 12.1839 26.7385C11.3197 27.5509 10.164 27.9998 8.94577 27.9998ZM8.94577 19.4487C8.17527 19.4487 7.44642 19.7159 6.8321 20.2183C6.19148 20.7404 5.75862 21.4847 5.61483 22.3114C5.47103 23.138 5.6262 23.9901 6.05119 24.7076C6.66551 25.7765 7.74837 26.3965 8.94577 26.3965C9.76833 26.3965 10.5597 26.0865 11.1636 25.5307C11.4343 25.2955 11.6633 25.0176 11.8299 24.7183C12.1631 24.1732 12.3297 23.5532 12.3297 22.9226C12.3297 21.0093 10.8095 19.4487 8.94577 19.4487Z"
              fill={getColorOnIsActive(ADD_FUNDS)}
            />
            <path
              d="M10.4969 23.7029H7.38369C6.9568 23.7029 6.60278 23.3395 6.60278 22.9013C6.60278 22.463 6.9568 22.0996 7.38369 22.0996H10.4969C10.704 22.0996 10.9027 22.1841 11.0491 22.3344C11.1956 22.4848 11.2778 22.6887 11.2778 22.9013C11.2778 23.1139 11.1956 23.3178 11.0491 23.4681C10.9027 23.6185 10.704 23.7029 10.4969 23.7029Z"
              fill={getColorOnIsActive(ADD_FUNDS)}
            />
            <path
              d="M8.94546 25.3384C8.51856 25.3384 8.16455 24.975 8.16455 24.5367V21.3407C8.16455 20.9025 8.51856 20.5391 8.94546 20.5391C9.37236 20.5391 9.72637 20.9025 9.72637 21.3407V24.5367C9.72637 24.9857 9.37236 25.3384 8.94546 25.3384Z"
              fill={getColorOnIsActive(ADD_FUNDS)}
            />
          </svg>
        );
      case "affiliate":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.529 19.342C23.0188 18.1636 21.1934 16.5279 19.4297 14.9474C18.446 14.0666 17.5165 13.2338 16.924 12.5774C16.7755 12.4118 16.5535 12.359 16.3574 12.437C15.9923 12.5834 15.767 12.6962 15.5893 12.7838C15.3185 12.9182 15.2275 12.9638 14.8624 13.0046C14.7829 13.0133 14.7061 13.0413 14.6376 13.0868C14.569 13.1322 14.5104 13.1939 14.4659 13.2674C13.7 14.5358 12.907 14.4278 12.3772 14.231C12.2082 14.1686 12.1779 14.0882 12.1617 14.0114C12.0479 13.4846 12.6188 12.2582 13.3587 11.4385C15.1192 9.48729 16.027 8.99885 17.9445 9.9481C20.1198 11.0257 22.2995 11.8694 22.3212 11.8777C22.3884 11.9038 22.4596 11.9149 22.5307 11.9105C22.6018 11.906 22.6714 11.886 22.7355 11.8517C22.7996 11.8173 22.8569 11.7693 22.9043 11.7103C22.9516 11.6514 22.9879 11.5827 23.0112 11.5081C23.1087 11.1949 22.9603 10.8529 22.6775 10.7437C22.6559 10.7353 20.5195 9.9085 18.3875 8.85125C15.9035 7.6212 14.5406 8.43122 12.5939 10.5889C11.8529 11.4097 10.8464 13.0706 11.1064 14.2886C11.218 14.807 11.5474 15.1911 12.037 15.3698C13.2644 15.8187 14.3846 15.389 15.2187 14.1626C15.5632 14.1038 15.7507 14.0174 16.0323 13.877C16.1576 13.8143 16.2841 13.7543 16.4115 13.697C17.0312 14.3414 17.8675 15.0914 18.7482 15.8799C20.3407 17.3067 22.1467 18.9244 22.5529 19.8604C22.7534 20.3224 22.5377 20.6236 22.3915 20.7616C22.177 20.9656 21.8834 21.0304 21.7242 20.9068C21.5487 20.7736 21.3201 20.7652 21.1392 20.8852C21.0501 20.944 20.9782 21.0298 20.9319 21.1326C20.8856 21.2353 20.867 21.3506 20.8781 21.4648C20.9149 21.8464 20.5997 22.0648 20.4632 22.1404C20.1165 22.3348 19.7547 22.3012 19.6192 22.162C19.4676 22.006 19.2498 21.9604 19.057 22.0396C18.8642 22.12 18.7298 22.3168 18.7103 22.5448C18.6778 22.9384 18.4146 23.3164 18.0711 23.464C17.9054 23.5336 17.6649 23.5756 17.4493 23.3572C17.3832 23.2912 17.3036 23.244 17.2173 23.2198C17.1311 23.1955 17.0408 23.1949 16.9542 23.218C16.8676 23.2414 16.7876 23.2882 16.7213 23.3541C16.6549 23.4201 16.6043 23.5031 16.574 23.596C16.5534 23.656 16.5068 23.8 15.9998 23.8C15.6391 23.8 14.9901 23.53 14.6727 23.2972C14.2925 23.02 11.9081 21.0495 9.84867 19.1391C9.55942 18.8691 9.05892 18.2906 8.61692 17.7794C8.22474 17.3258 7.86617 16.9142 7.68199 16.7414C7.45124 16.5254 7.10999 16.5578 6.91824 16.8122C6.72542 17.0654 6.75355 17.4447 6.98217 17.6583C7.1501 17.8155 7.4751 18.1958 7.83367 18.6099C8.31685 19.1691 8.81624 19.7475 9.1521 20.0595C11.1693 21.9304 13.5938 23.95 14.0769 24.3016C14.4756 24.592 15.3347 25 15.9999 25C16.5339 25 16.9445 24.8644 17.2294 24.5992C17.6107 24.7637 18.0441 24.7648 18.4612 24.5848C18.9541 24.3736 19.3592 23.9476 19.5889 23.4316C20.0157 23.5324 20.5044 23.4616 20.9485 23.2144C21.3829 22.972 21.6971 22.6012 21.8531 22.168C22.2842 22.1932 22.7284 22.024 23.0956 21.6748C23.7175 21.0856 23.8887 20.1688 23.529 19.342Z"
              fill={getColorOnIsActive(AFFILIATES)}
              stroke={getColorOnIsActive(AFFILIATES)}
              strokeWidth="0.25"
            />
            <path
              d="M13.8332 9.39941H8.95819C8.65919 9.39941 8.4165 9.66824 8.4165 9.99945C8.4165 10.3307 8.65919 10.5995 8.95819 10.5995H13.8332C14.1322 10.5995 14.3749 10.3307 14.3749 9.99945C14.3749 9.66824 14.1322 9.39941 13.8332 9.39941ZM25.1161 18.0648C24.9482 17.79 24.6124 17.7144 24.3643 17.9016L22.7805 19.0801C22.5324 19.2648 22.4663 19.6381 22.6332 19.9129C22.683 19.9945 22.7501 20.0614 22.8287 20.1076C22.9073 20.1539 22.9949 20.1781 23.0839 20.1781C23.1868 20.1781 23.2919 20.1457 23.385 20.0761L24.9689 18.8977C25.2169 18.7129 25.2829 18.3397 25.1161 18.0648ZM21.7534 20.9281C21.3656 20.5897 19.6312 18.6229 18.5587 17.3845C18.3518 17.1444 18.0084 17.1361 17.7928 17.3665C17.5761 17.5957 17.5696 17.9761 17.7765 18.2149C18.0549 18.5365 20.5108 21.3722 21.0818 21.8714C21.1771 21.9548 21.2951 22 21.4165 21.9998C21.5758 21.9998 21.735 21.9206 21.8433 21.7706C22.0286 21.5114 21.9886 21.1333 21.7534 20.9281ZM19.5889 22.1318C18.94 21.5569 17.3096 19.6381 16.9413 19.1941C16.7376 18.9493 16.3963 18.9349 16.1753 19.1581C15.9554 19.3825 15.9403 19.7629 16.1428 20.0065C16.1623 20.0293 18.108 22.3562 18.9118 23.069C19.008 23.1536 19.1271 23.1997 19.2498 23.1998C19.408 23.1998 19.5661 23.1218 19.6734 22.9754C19.8598 22.7162 19.8219 22.3381 19.5889 22.1318ZM17.4331 23.3402C16.6607 22.619 15.0801 20.7553 14.7714 20.3893C14.5666 20.1469 14.2232 20.1337 14.0054 20.3605C13.7866 20.5873 13.7758 20.9665 13.9794 21.209C14.4236 21.7357 15.9359 23.5118 16.7344 24.2582C16.8319 24.3496 16.9555 24.3998 17.0832 24.3998C17.237 24.3998 17.3909 24.3266 17.4981 24.1862C17.6909 23.9318 17.6617 23.5538 17.4331 23.3402Z"
              fill={getColorOnIsActive(AFFILIATES)}
              stroke={getColorOnIsActive(AFFILIATES)}
              strokeWidth="0.25"
            />
            <path
              d="M9.331 8.36407C8.40257 7.38963 4.69 7.074 3.57418 7.00082C3.42037 6.99243 3.27843 7.0488 3.17012 7.16282C3.11637 7.21892 3.07355 7.28662 3.04429 7.36173C3.01504 7.43685 2.99996 7.5178 3 7.59961V18.3999C3 18.7311 3.24268 18.9999 3.54168 18.9999H6.79168C7.02568 18.9999 7.23368 18.8331 7.30625 18.5859C7.38532 18.3171 9.25193 11.9714 9.49782 8.85126C9.51193 8.66884 9.45125 8.48883 9.331 8.36407ZM6.39625 17.7999H4.08332V8.24285C5.82425 8.39523 7.70275 8.72644 8.38525 9.09365C8.09818 11.7217 6.79925 16.391 6.39625 17.7999ZM28.4583 8.19965C24.2051 8.19965 21.8456 9.40568 21.7471 9.45608C21.6063 9.52926 21.5011 9.66488 21.4578 9.82931C21.4145 9.99373 21.4361 10.1701 21.5174 10.3165C22.1869 11.5105 24.2831 18.1419 24.6861 19.7595C24.7177 19.8861 24.7858 19.9978 24.8801 20.0773C24.9745 20.1569 25.0898 20.2 25.2083 20.1999H28.4583C28.7573 20.1999 29 19.9311 29 19.5999V8.79962C29.0001 8.72081 28.9861 8.64276 28.9589 8.56993C28.9317 8.4971 28.8918 8.43093 28.8415 8.37521C28.7912 8.31948 28.7314 8.27529 28.6657 8.24517C28.5999 8.21504 28.5295 8.19957 28.4583 8.19965ZM27.9167 18.9999H25.6135C25.1 17.1471 23.5833 12.3157 22.7372 10.3189C23.5638 10.0081 25.3394 9.47408 27.9167 9.40691V18.9999Z"
              fill={getColorOnIsActive(AFFILIATES)}
              stroke={getColorOnIsActive(AFFILIATES)}
              strokeWidth="0.25"
            />
          </svg>
        );
      case "tickets":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.4781 17.0444C27.7911 17.0444 28 16.8356 28 16.5226V13.3924C28 12.5054 27.3219 11.8272 26.4349 11.8272H25.7562C25.913 11.097 26.3823 10.471 27.1125 10.2621C27.2472 10.2199 27.3598 10.1261 27.4255 10.0012C27.4756 9.89702 27.4756 9.74026 27.4255 9.584L26.3823 6.61054C26.226 6.19334 25.9651 5.88032 25.6 5.72356C25.2349 5.5668 24.8177 5.51471 24.398 5.67348L6.60982 11.8277H5.56658C4.6796 11.8277 4.00146 12.5059 4.00146 13.3929V16.5231C4.00146 16.8361 4.21031 17.0449 4.52334 17.0449C4.80009 17.0407 5.07493 17.0915 5.33186 17.1944C5.58879 17.2973 5.82268 17.4504 6.01991 17.6446C6.21714 17.8388 6.37376 18.0703 6.48068 18.3256C6.58759 18.5809 6.64265 18.8549 6.64265 19.1317C6.64265 19.4085 6.58759 19.6825 6.48068 19.9378C6.37376 20.1931 6.21714 20.4246 6.01991 20.6188C5.82268 20.813 5.58879 20.966 5.33186 21.0689C5.07493 21.1719 4.80009 21.2227 4.52334 21.2184C4.21031 21.2184 4.00146 21.4273 4.00146 21.7403V24.8705C4.00146 25.7575 4.6796 26.4356 5.56658 26.4356H26.4344C27.3214 26.4356 27.9995 25.7575 27.9995 24.8705V21.7403C27.9995 21.4273 27.7906 21.2184 27.4776 21.2184C26.9298 21.2099 26.4073 20.9863 26.0228 20.5959C25.6384 20.2055 25.423 19.6796 25.423 19.1317C25.423 18.5838 25.6384 18.0578 26.0228 17.6674C26.4073 17.277 26.9298 17.0534 27.4776 17.0449L27.4781 17.0444ZM24.7651 6.66263C24.8993 6.61049 25.0481 6.61049 25.1823 6.66263C25.3072 6.72841 25.401 6.84094 25.4432 6.97565L26.3302 9.47983C25.4432 9.94961 24.8693 10.8361 24.713 11.8277H9.79012L24.7651 6.66263ZM5.0447 24.87V22.2116C6.50564 21.9506 7.65306 20.6985 7.65306 19.1334C7.65306 17.5683 6.50564 16.3142 5.0447 16.0513V13.3929C5.0447 13.0798 5.25355 12.871 5.56658 12.871H21.739V25.3919H5.56658C5.25355 25.3919 5.0447 25.183 5.0447 24.87ZM26.9562 22.2116V24.8725C26.9562 25.1855 26.7474 25.3944 26.4344 25.3944H22.7828V12.8735H26.4349C26.7479 12.8735 26.9568 13.0823 26.9568 13.3954V16.0513C25.4958 16.3122 24.3484 17.5643 24.3484 19.1294C24.3484 20.6945 25.4953 21.9486 26.9562 22.2116Z"
              fill={getColorOnIsActive(TICKETS)}
              stroke={getColorOnIsActive(TICKETS)}
              strokeWidth="0.4"
            />
            <path
              d="M10.7833 17.0447H13.9136C14.2266 17.0447 14.4354 16.8359 14.4354 16.5228C14.4354 16.2098 14.2266 16.0015 13.9136 16.0015H10.7833C10.4703 16.0015 10.2615 16.2103 10.2615 16.5233C10.2615 16.8364 10.4703 17.0447 10.7833 17.0447Z"
              fill={getColorOnIsActive(TICKETS)}
              stroke={getColorOnIsActive(TICKETS)}
              strokeWidth="0.4"
            />
            <path
              d="M17.5657 18.6094H10.7833C10.4703 18.6094 10.2615 18.8182 10.2615 19.1312C10.2615 19.4443 10.4703 19.6531 10.7833 19.6531H17.5657C17.8787 19.6531 18.0875 19.4443 18.0875 19.1312C18.0875 18.8182 17.8787 18.6094 17.5657 18.6094ZM17.5657 21.2182H10.7833C10.4703 21.2182 10.2615 21.4271 10.2615 21.7401C10.2615 22.0531 10.4703 22.2615 10.7833 22.2615H17.5657C17.8787 22.2615 18.0875 22.0526 18.0875 21.7396C18.0875 21.4266 17.8787 21.2182 17.5657 21.2182Z"
              fill={getColorOnIsActive(TICKETS)}
              stroke={getColorOnIsActive(TICKETS)}
              strokeWidth="0.4"
            />
          </svg>
        );
      case "contact":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.3613 7.71306H11.4527L9.88332 4.99493C9.59924 4.50289 9.15617 4.17663 8.60192 4.05153C8.04761 3.92623 7.50736 4.03052 7.03952 4.35271L3.52642 6.77146C3.40794 6.85302 3.32162 6.97336 3.28235 7.11173C2.85397 8.62118 2.94914 10.5411 3.56525 12.8181C4.11595 14.8535 5.06255 17.0645 6.30264 19.2124C8.42341 22.8856 11.9089 27.1182 15.3314 27.9813C15.4709 28.0165 15.6183 28.0019 15.7482 27.9401L19.5994 26.107C20.1124 25.8629 20.4728 25.4471 20.6415 24.9044C20.8101 24.3618 20.7492 23.815 20.4651 23.3231L19.9113 22.364H27.3613C28.2529 22.364 28.9782 21.6387 28.9782 20.7471V9.32989C28.9782 8.43841 28.2529 7.71306 27.3613 7.71306ZM12.0379 8.94909H26.3657L18.5759 14.2893L12.0144 9.79109C12.0818 9.51526 12.0898 9.22825 12.0379 8.94909ZM19.4612 24.5375C19.3948 24.7509 19.2699 24.895 19.0682 24.9911L15.4253 26.7249C12.9444 25.972 9.81044 22.816 7.37304 18.5944C4.93297 14.3681 3.81446 10.2115 4.41698 7.65893L7.74046 5.37068C7.92442 5.24399 8.11178 5.20789 8.32963 5.25712C8.54753 5.30636 8.70111 5.41935 8.81281 5.61289L10.7392 8.9494C10.9407 9.29853 10.8246 9.75308 10.4803 9.96274L8.34657 11.262C8.23777 11.3282 8.15209 11.4265 8.10128 11.5433C8.05047 11.6602 8.03699 11.7899 8.0627 11.9146C8.67505 14.8846 11.2963 19.4247 13.5622 21.4399C13.6573 21.5246 13.7764 21.5778 13.903 21.5922C14.0296 21.6066 14.1575 21.5815 14.2693 21.5204L16.4613 20.3221C16.815 20.1288 17.2668 20.2554 17.4683 20.6045L19.3947 23.9411C19.5064 24.1346 19.5275 24.3241 19.4612 24.5375ZM27.3613 21.128H19.1977L18.5388 19.9866C18.0042 19.0608 16.8063 18.7248 15.8684 19.2376L14.0691 20.2212C12.1767 18.3534 10.043 14.6577 9.37165 12.085L11.1231 11.0186C11.208 10.9668 11.289 10.9086 11.3651 10.8446L18.2264 15.5483C18.3317 15.6205 18.4538 15.6566 18.5759 15.6566C18.6979 15.6566 18.82 15.6205 18.9253 15.5483L27.7421 9.50402V20.7472C27.7421 20.9536 27.5677 21.128 27.3613 21.128Z"
              fill={getColorOnIsActive(CONTACT)}
              stroke={getColorOnIsActive(CONTACT)}
              strokeWidth="0.25"
            />
          </svg>
        );
      case "api":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_331_559"
              maskUnits="userSpaceOnUse"
              x="3"
              y="4"
              width="25"
              height="24"
            >
              <path
                d="M27.2499 27.25V4.74985H4.74976V27.25H27.2499Z"
                fill="white"
                stroke="white"
                strokeWidth="1.5"
              />
            </mask>
            <g mask="url(#mask0_331_559)">
              <path
                d="M24.4122 10.6255C24.4172 10.541 24.4374 10.4608 24.4374 10.3749C24.4374 8.04501 22.5486 6.1093 20.2186 6.1093C19.2617 6.1093 18.3894 6.44 17.6816 6.97691C16.6559 5.60412 15.0328 4.70304 13.1873 4.70304C10.0806 4.70304 7.56227 7.26829 7.56227 10.3749C7.56227 10.4608 7.58374 10.5406 7.58749 10.6255C5.93973 11.1996 4.70288 12.7503 4.70288 14.5937C4.70288 16.9237 6.63855 18.8125 8.96853 18.8125H23.0311C25.3611 18.8125 27.2968 16.9237 27.2968 14.5937C27.2968 12.7503 26.0599 11.1996 24.4122 10.6255Z"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.96875 16L11.0781 10.375L13.1875 16"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16 16V10.375H17.4063C18.1829 10.375 18.8125 11.0046 18.8125 11.7812C18.8125 12.5579 18.1829 13.1875 17.4063 13.1875H16"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M21.625 10.375V16"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.49609 14.5938H12.6602"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.96874 18.8124C8.96874 19.5891 9.12549 20.3235 9.35921 21.0227L7.98975 21.8134L9.396 24.2491L10.7642 23.4592C11.756 24.5756 13.0766 25.3924 14.5938 25.7016V27.2969H17.4063V25.7016C18.9235 25.3924 20.244 24.5756 21.2359 23.4592L22.6041 24.2491L24.0103 21.8134L22.6409 21.0227C22.8746 20.3235 23.0313 19.5891 23.0313 18.8124"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.2188 18.8125C20.2188 21.1425 18.33 23.0312 16 23.0312C13.67 23.0312 11.7812 21.1425 11.7812 18.8125"
                stroke={getColorOnIsActive(API)}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      case "mass-order":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.2914 26.8571H6.85714C6.09966 26.8562 5.37346 26.5549 4.83784 26.0193C4.30222 25.4837 4.00091 24.7575 4 24V6.85714C4.00091 6.09966 4.30222 5.37346 4.83784 4.83784C5.37346 4.30222 6.09966 4.00091 6.85714 4H22.8571C23.6146 4.00091 24.3408 4.30222 24.8764 4.83784C25.4121 5.37346 25.7134 6.09966 25.7143 6.85714V17.1486C25.7143 17.3001 25.6541 17.4455 25.5469 17.5526C25.4398 17.6598 25.2944 17.72 25.1429 17.72C24.9913 17.72 24.846 17.6598 24.7388 17.5526C24.6316 17.4455 24.5714 17.3001 24.5714 17.1486V6.85714C24.5714 6.40249 24.3908 5.96645 24.0693 5.64496C23.7478 5.32347 23.3118 5.14286 22.8571 5.14286H6.85714C6.40249 5.14286 5.96645 5.32347 5.64496 5.64496C5.32347 5.96645 5.14286 6.40249 5.14286 6.85714V24C5.14286 24.4547 5.32347 24.8907 5.64496 25.2122C5.96645 25.5337 6.40249 25.7143 6.85714 25.7143H18.2914C18.443 25.7143 18.5883 25.7745 18.6955 25.8817C18.8027 25.9888 18.8629 26.1342 18.8629 26.2857C18.8629 26.4373 18.8027 26.5826 18.6955 26.6898C18.5883 26.7969 18.443 26.8571 18.2914 26.8571Z"
              fill={getColorOnIsActive(MASS_ORDER)}
              stroke={getColorOnIsActive(MASS_ORDER)}
              strokeWidth="0.5"
            />
            <path
              d="M14.8571 13.1429C14.6204 13.11 14.3933 13.0275 14.1908 12.9007C13.9882 12.774 13.8147 12.6059 13.6816 12.4074C13.3959 12.0949 13.0965 11.7714 12.7976 11.7714C12.7125 11.7714 12.6262 11.8006 12.3976 12.1589C12.2663 12.369 12.0703 12.5307 11.8391 12.6197C11.6078 12.7087 11.3539 12.7202 11.1156 12.6524C10.8773 12.5845 10.6675 12.4411 10.5178 12.2437C10.3681 12.0462 10.2866 11.8055 10.2856 11.5577V4.57143C10.2856 4.41988 10.3458 4.27453 10.453 4.16737C10.5602 4.0602 10.7055 4 10.8571 4H18.8571C19.0086 4 19.154 4.0602 19.2611 4.16737C19.3683 4.27453 19.4285 4.41988 19.4285 4.57143V11.7354C19.4285 11.9748 19.3533 12.2081 19.2136 12.4025C19.0739 12.5969 18.8767 12.7425 18.6498 12.8188C18.4229 12.895 18.1777 12.8981 17.949 12.8276C17.7202 12.7571 17.5194 12.6165 17.3748 12.4257L17.3142 12.3429C17.0456 11.9863 16.8696 11.7714 16.6816 11.7714C16.4371 11.7714 16.2434 12.0057 15.9754 12.3629C15.8648 12.5727 15.7055 12.753 15.511 12.8887C15.3164 13.0244 15.0922 13.1116 14.8571 13.1429ZM12.7999 10.6286C13.1424 10.6638 13.4735 10.7717 13.7709 10.945C14.0684 11.1184 14.3255 11.3531 14.5251 11.6337C14.6251 11.7466 14.731 11.8541 14.8422 11.956C14.9096 11.8823 14.9976 11.7646 15.0622 11.6783C15.2262 11.3848 15.4594 11.1357 15.7416 10.9528C16.0237 10.7699 16.3462 10.6586 16.6811 10.6286C17.0022 10.6627 17.3102 10.7741 17.5789 10.9532C17.8476 11.1324 18.0689 11.3739 18.2239 11.6571L18.2811 11.7354V5.14286H11.4285V11.5669C11.551 11.3012 11.7432 11.0736 11.9847 10.9084C12.2262 10.7432 12.5079 10.6465 12.7999 10.6286ZM21.7142 28C20.471 28 19.2557 27.6313 18.2221 26.9407C17.1884 26.25 16.3827 25.2683 15.907 24.1197C15.4312 22.9712 15.3067 21.7073 15.5493 20.488C15.7918 19.2687 16.3905 18.1487 17.2695 17.2696C18.1486 16.3905 19.2686 15.7919 20.4879 15.5494C21.7072 15.3068 22.9711 15.4313 24.1197 15.907C25.2682 16.3828 26.2499 17.1884 26.9406 18.2221C27.6313 19.2558 27.9999 20.4711 27.9999 21.7143C27.998 23.3808 27.3351 24.9784 26.1567 26.1568C24.9783 27.3352 23.3807 27.998 21.7142 28ZM21.7142 16.5714C20.6971 16.5714 19.7027 16.8731 18.857 17.4382C18.0113 18.0033 17.3521 18.8065 16.9628 19.7462C16.5736 20.6859 16.4717 21.72 16.6702 22.7176C16.8686 23.7152 17.3584 24.6316 18.0777 25.3508C18.7969 26.0701 19.7133 26.5599 20.7109 26.7583C21.7085 26.9568 22.7426 26.8549 23.6823 26.4657C24.622 26.0764 25.4252 25.4172 25.9903 24.5715C26.5555 23.7258 26.8571 22.7314 26.8571 21.7143C26.8556 20.3508 26.3132 19.0436 25.3491 18.0794C24.385 17.1153 23.0777 16.5729 21.7142 16.5714Z"
              fill={getColorOnIsActive(MASS_ORDER)}
              stroke={getColorOnIsActive(MASS_ORDER)}
              strokeWidth="0.5"
            />
            <path
              d="M21.7143 24.5712C21.5627 24.5712 21.4174 24.511 21.3102 24.4039C21.203 24.2967 21.1428 24.1513 21.1428 23.9998V19.4284C21.1428 19.2768 21.203 19.1315 21.3102 19.0243C21.4174 18.9171 21.5627 18.8569 21.7143 18.8569C21.8658 18.8569 22.0111 18.9171 22.1183 19.0243C22.2255 19.1315 22.2857 19.2768 22.2857 19.4284V23.9998C22.2857 24.1513 22.2255 24.2967 22.1183 24.4039C22.0111 24.511 21.8658 24.5712 21.7143 24.5712Z"
              fill={getColorOnIsActive(MASS_ORDER)}
              stroke={getColorOnIsActive(MASS_ORDER)}
              strokeWidth="0.5"
            />
            <path
              d="M24 22.2859H19.4286C19.2771 22.2859 19.1317 22.2257 19.0245 22.1186C18.9174 22.0114 18.8572 21.866 18.8572 21.7145C18.8572 21.5629 18.9174 21.4176 19.0245 21.3104C19.1317 21.2033 19.2771 21.1431 19.4286 21.1431H24C24.1516 21.1431 24.2969 21.2033 24.4041 21.3104C24.5113 21.4176 24.5715 21.5629 24.5715 21.7145C24.5715 21.866 24.5113 22.0114 24.4041 22.1186C24.2969 22.2257 24.1516 22.2859 24 22.2859Z"
              fill={getColorOnIsActive(MASS_ORDER)}
              stroke={getColorOnIsActive(MASS_ORDER)}
              strokeWidth="0.5"
            />
          </svg>
        );
      case "plans":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 96 96"
            width="32"
            height="32"
            fill="none"
          >
            <path
              d="M71.3,74.06a1,1,0,0,1-1-1V17a3,3,0,0,0-3-3h-11a1,1,0,0,1,0-2h11a5,5,0,0,1,5,5V73.06A1,1,0,0,1,71.3,74.06Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,86.51H18.74a5,5,0,0,1-5-5V17a5,5,0,0,1,5-5h11a1,1,0,0,1,0,2h-11a3,3,0,0,0-3,3V81.5a3,3,0,0,0,3,3H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M71.3,94a11,11,0,1,1,11-11A11,11,0,0,1,71.3,94Zm0-19.94a9,9,0,1,0,9,9A9,9,0,0,0,71.3,74.06Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,29.43H24.7a1,1,0,1,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,37.34H24.7a1,1,0,0,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,45.25H24.7a1,1,0,0,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,53.16H24.7a1,1,0,0,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,61.07H24.7a1,1,0,1,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M61.33,69H24.7a1,1,0,0,1,0-2H61.33a1,1,0,0,1,0,2Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M56.27,18.14H29.76a1,1,0,0,1-1-1v-8a1,1,0,0,1,1-1H56.27a1,1,0,0,1,1,1v8A1,1,0,0,1,56.27,18.14Zm-25.51-2H55.27v-6H30.76Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M35.15,10.16a1,1,0,0,1-.95-1.33C35.68,4.68,39.14,2,43,2s7.31,2.67,8.8,6.81a1,1,0,0,1-1.88.67C48.74,6.15,46,4,43,4s-5.74,2.16-6.93,5.5A1,1,0,0,1,35.15,10.16Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
            <path
              d="M69.87,86.9h0a1,1,0,0,1-.7-.3L66.3,83.74a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.16,2.16,5-5a1,1,0,1,1,1.41,1.41L70.58,86.6A1,1,0,0,1,69.87,86.9Z"
              fill={getColorOnIsActive(PLANS)}
              stroke={getColorOnIsActive(PLANS)}
              strokeWidth="1.5"
            />
          </svg>
        );
      case "child-panel":
        return (
          <UserAddOutlined
            className={`pl-2 text-[20px] text-[${getColorOnIsActive(CHILD_PANEL)}]`}
          />
        );
    }
  };

  return (
    <div className="h-auto flex-col gap-4 bg-white p-2 md:flex md:h-[100%] md:w-[260px] md:p-4">
      {/* User Profile - Top of sidebar */}
      <div className="mb-4 rounded-lg bg-[#F8F7FA] p-4">
        <div className="flex items-center gap-3">
          {/* User avatar - positioned at the left */}
          <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full border-2 border-white">
            <img
              src={`https://ui-avatars.com/api/?name=${GetUserName()}&background=random`}
              alt="User avatar"
              className="h-full w-full object-cover"
            />
          </div>

          {/* Account information at the right */}
          <div className="flex-1">
            <h3 className="text-[15px] font-medium text-[#212121]">
              {GetUserName()}
            </h3>
          </div>
        </div>
        <div className="mt-1 flex flex-col gap-1">
          <p className="text-xs text-[#666270]">Account balance</p>
          <p className="text-xl font-bold text-[#212121]">{GetBalance()}$</p>
        </div>
      </div>

      {/* Navigation Menu */}
      <div className="flex flex-col gap-2">
        {navItemsData.map((item) => (
          <Link
            to={item.to}
            className={getLinkClassName(item.to)}
            key={item.to}
            onClick={() => {
              if (onClose) {
                setTimeout(() => {
                  onClose();
                }, 200);
                // onClose();
              }
            }}
          >
            {icon(item.icon)}
            <span className={getTextClassName(item.to)}>{item.label}</span>
          </Link>
        ))}
      </div>
      {/* Footer */}
      <div className="mt-auto hidden border-t border-[#F1EFF5] p-4 md:block">
        <div className="flex flex-col gap-3">
          <div className="mt-2 text-xs text-[#666270]">
            <p>© 2025 {window.location.hostname.toUpperCase()}</p>
            <p>Version 1.0.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
